import { useEffect, useRef, useState } from 'react';

export const THINKING_ESCALATION_MS = 15000;

/**
 * Escalates a "thinking" label after a delay while waiting for the first token.
 *
 * @param {boolean} active
 * @param {number} [delayMs]
 * @returns {boolean}
 */
export function useThinkingEscalation(
  active,
  delayMs = THINKING_ESCALATION_MS,
) {
  const [thinkingLong, setThinkingLong] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (active) {
      timerRef.current = setTimeout(() => {
        setThinkingLong(true);
      }, delayMs);
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setThinkingLong(false);
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [active, delayMs]);

  return thinkingLong;
}
